import { useMemo } from "react";
import { languageService, sessionService } from "services";
import { useAppSettings } from "shared/context/AppSettingsContext";
import { handleError } from "shared/errors/handleError";

const noop = async () => Promise.resolve({});

export const useSession = () => {
    const appSettings = useAppSettings();
    const sourceLanguage = useMemo(() => languageService.getLocale(appSettings.settings.sourceLanguage, appSettings.settings.sourceDialect), [appSettings.settings.sourceLanguage, appSettings.settings.sourceDialect]);
    const targetLanguage = useMemo(() => languageService.getLocale(appSettings.settings.targetLanguage, appSettings.settings.targetDialect), [appSettings.settings.targetLanguage, appSettings.settings.targetDialect]);

    const withSessionErrorHandler = (func) => {
        return async function (...args) {
            try {
                await func(args);
            } catch (err) {
                handleError(err)
            }
        }
    }

    // Todo: Uncomment the following code to enable session handling
    return {
        startSession: withSessionErrorHandler(sessionService.startSession),
        logoutSession: withSessionErrorHandler(sessionService.logoutSession),
        startSessionConversation: withSessionErrorHandler(async () => {
            const { conversation_id: conversationId } = await sessionService.startConversation({
                source_language: sourceLanguage.code,
                target_language: targetLanguage.translationCode ? targetLanguage.translationCode : targetLanguage.code,
            });
            appSettings.updateSettings({ conversationId });
        }),
        endSessionConversation: withSessionErrorHandler(async () => {
            await sessionService.endConversation({
                conversation_id: appSettings.settings.conversationId,
            });
        }),
    };

    // return {
    //     startSession: withSessionErrorHandler(noop),
    //     logoutSession: withSessionErrorHandler(noop),
    //     startSessionConversation: withSessionErrorHandler(noop),
    //     endSessionConversation: withSessionErrorHandler(noop),
    // };
}
